import React from 'react';
import { styled, css, useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

export interface ISvg extends IIcon {
  direction?: 'right' | 'left' | 'top' | 'bottom';
}

const Svg = styled.svg`
  ${({ direction }) =>
    direction === 'left' &&
    css`
      transform: rotate(-180deg);
    `}
  ${({ direction }) =>
    direction === 'top' &&
    css`
      transform: rotate(-90deg);
    `}
  ${({ direction }) =>
    direction === 'bottom' &&
    css`
      transform: rotate(90deg);
    `}
`;

const Icon = React.forwardRef<SVGSVGElement | null, ISvg>(function Icon({ size = 24, alt, color, className, onClick, direction }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <Svg
      ref={ref}
      onClick={onClick}
      width={size}
      height={size}
      viewBox='0 0 426.667 426.667'
      fill='none'
      className={className}
      direction={direction}>
      <polygon fillRule='evenodd' clipRule='evenodd' points='170.667,309.333 298.667,213.333 170.667,117.333 ' fill={fillColor} />
    </Svg>
  );
});

export default React.memo(Icon);
